import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 0.5fr',
    gap: 5,
    alignItems: 'center',
    padding: '10px 0px 10px 12px',
    color: 'grey',
    backgroundColor: theme.palette.background.default,
    height: '3.3rem'
  },
  tableRowOdd: {
    backgroundColor: theme.palette.grey[200]
  },
  tableRowSkeleton: {
    height: '3.3rem'
  },
  text: {
    color: theme.palette.grey[800],
    fontSize: lang === 'en' ? '16px' : '15px'
  },
  icon: {
    textAlign: 'right'
  },
  checkIcon: {
    color: theme.palette.success.main
  },
  closeIcon: {
    color: theme.palette.error.main
  },
  CheckBoxContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  checkBoxPadding: {
    padding: '3.5px 9px 3.5px 0px'
  },
  skeleton: {
    width: '80%'
  },
  skeletonCheckBox: {
    width: '20%'
  }
}))
export default useStyles
